import { render, staticRenderFns } from "./inputMaker.vue?vue&type=template&id=0af21f68"
import script from "./inputMaker.vue?vue&type=script&lang=js"
export * from "./inputMaker.vue?vue&type=script&lang=js"
import style0 from "./inputMaker.vue?vue&type=style&index=0&id=0af21f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports